import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchCountries } from '@app/api'
import { getUserLanguage } from '@app/utils'

export const getCountriesThunk = createAsyncThunk(
  'countries',
  async () => {
    const userLanguage = getUserLanguage()

    return await fetchCountries(userLanguage)
  }
)
